import { useParams } from "react-router";
import _ from "lodash";

import { colors } from "theme/palette";

import Stack from "components/Stack";
import Text from "components/Text";

import { useOnboardingCompanyPackageCategorizedFileFieldCounts } from "entities/Deal/sdk";

import CategoryTag from "./CategoryTag";

const OnboardingChecklistFieldCategories = () => {
  const params = useParams<{
    dealId: string;
  }>();
  const dealId = Number(params.dealId);

  const {
    data: onboardingCompanyPackageCategorizedFileFieldCounts,
    isLoading: isLoadingOnboardingCompanyPackageCategorizedFileFieldCounts,
  } = useOnboardingCompanyPackageCategorizedFileFieldCounts({
    dealId,
  });

  const isLoading =
    _.isNil(onboardingCompanyPackageCategorizedFileFieldCounts) ||
    isLoadingOnboardingCompanyPackageCategorizedFileFieldCounts;

  return (
    <Stack>
      <Text variant="labelSmall" marginBottom={1}>
        PROGRESS OF AI DATA EXTRACTION FROM DOCUMENTS
      </Text>

      <Stack spacing={0.5} direction="row">
        <CategoryTag
          isLoading={isLoading}
          backgroundColor={colors.red40}
          text="missing"
          circleBackgroundColor={colors.black}
          count={onboardingCompanyPackageCategorizedFileFieldCounts?.missing}
        />
        <CategoryTag
          isLoading={isLoading}
          backgroundColor={colors.blue40}
          circleBackgroundColor={colors.black}
          count={
            onboardingCompanyPackageCategorizedFileFieldCounts?.categorized
          }
          text="categorized"
        />
        <CategoryTag
          isLoading={isLoading}
          backgroundColor={colors.blue80}
          circleBackgroundColor={colors.white}
          text="AI extracted"
          color={colors.white}
          count={
            onboardingCompanyPackageCategorizedFileFieldCounts?.ai_extracted
          }
        />
        <CategoryTag
          isLoading={isLoading}
          backgroundColor={colors.blue120}
          circleBackgroundColor={colors.white}
          text="reviewed"
          color={colors.white}
          count={onboardingCompanyPackageCategorizedFileFieldCounts?.reviewed}
        />
      </Stack>
    </Stack>
  );
};

export default OnboardingChecklistFieldCategories;
